type FormattableAddress = {
  name: string | null;
  line1: string | null;
  line2: string | null;
  town: string | null;
  county: string | null;
  postcode: string | null;
  country?: string | null;
};

export const formatFullAddress = (address: FormattableAddress): string => {
  return [address.name, address.line1, address.town, address.postcode].filter((line) => line && line.trim()).join(', ');
};
